import React from 'react';

const PageHeader = ({
  title,
  description,
  icon: Icon,
  iconGradient = 'from-primary-500 to-primary-600',
  actions,
  badge,
  showBreadcrumbs = false,
  className = '',
}) => (
  <div className={`flex flex-col md:flex-row md:items-center md:justify-between gap-4 ${className}`}>
    <div className="flex items-center gap-3">
      {Icon && (
        <div className={`p-3 bg-gradient-to-br ${iconGradient} rounded-2xl shadow-lg shrink-0`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
      )}
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{title}</h1>
        {description && (
          <p className="text-sm text-gray-500 dark:text-gray-400">{description}</p>
        )}
      </div>
      {badge}
    </div>

    {actions && (
      <div className="flex items-center gap-2 flex-wrap shrink-0">
        {actions}
      </div>
    )}
  </div>
);

export default PageHeader;
